import { render, staticRenderFns } from "./bannerAdd.vue?vue&type=template&id=32cba1dc&"
import script from "./bannerAdd.vue?vue&type=script&lang=js&"
export * from "./bannerAdd.vue?vue&type=script&lang=js&"
import style0 from "./bannerAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports